<template>
  <BaseButton
    :danger="rejected"
    :success="!rejected"
    type="button"
    class="w-full"
    @click="createConversation"
  >
    <Loader v-if="loading" small />
    <span v-else-if="rejected">Something went wrong.</span>
    <span v-else>Start conversation</span>
  </BaseButton>
</template>

<script>
export default {
  props: {
    contactRequest: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      resolved: false,
      rejected: false,
    };
  },
  methods: {
    setLoading(loading = true) {
      this.loading = Boolean(loading);
    },
    setResolved(resolved = true) {
      this.resolved = Boolean(resolved);
    },
    setRejected(rejected = true) {
      this.rejected = Boolean(rejected);
    },
    async createConversation() {
      try {
        this.setLoading();

        await this.$store.dispatch('ui/contactRequestConversation/store', {
          id: this.contactRequest.id,
          formData: {},
        });

        await this.$store.dispatch('ui/contactRequestConversation/read', {
          id: this.contactRequest.id,
          query: {},
        });

        this.$emit('created');

        this.setResolved();
      } catch (error) {
        this.setRejected();
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
